import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  id: "components-layout-demo-basic",
  class: "index"
};
const _hoisted_2 = {
  class: "login-div"
};
const _hoisted_3 = {
  key: 2,
  style: {
    "text-align": "left"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_input_password = _resolveComponent("a-input-password");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_tag = _resolveComponent("a-tag");
  const _component_a_card = _resolveComponent("a-card");
  const _component_a_layout_content = _resolveComponent("a-layout-content");
  const _component_a_layout_footer = _resolveComponent("a-layout-footer");
  const _component_a_layout = _resolveComponent("a-layout");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_layout, null, {
    default: _withCtx(() => [_createVNode(_component_a_layout_content, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_card, {
        title: _ctx.$t('login_title'),
        bodyStyle: "{padding:24px}"
      }, {
        default: _withCtx(() => [!$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_tabs, {
          key: 0,
          activeKey: $data.activeKey,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => $data.activeKey = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            key: "1",
            tab: _ctx.$t('user')
          }, null, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: _ctx.$t('team'),
            "force-render": ""
          }, null, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
            key: "3",
            tab: _ctx.$t('client')
          }, null, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
            key: "4",
            tab: _ctx.$t('internal')
          }, null, 8, ["tab"])]),
          _: 1
        }, 8, ["activeKey"])) : _createCommentVNode("", true), _createVNode(_component_a_input, {
          value: $data.account,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => $data.account = $event),
          placeholder: _ctx.$t('ph_phone_email1')
        }, null, 8, ["value", "placeholder"]), _createVNode(_component_a_input_password, {
          value: $data.password,
          "onUpdate:value": _cache[2] || (_cache[2] = $event => $data.password = $event),
          placeholder: _ctx.$t('ph_password')
        }, null, 8, ["value", "placeholder"]), _withDirectives(_createVNode(_component_a_select, {
          dropdownMatchSelectWidth: false,
          getPopupContainer: triggerNode => triggerNode.parentNode || _ctx.document.body,
          value: $data.auth_uid,
          "onUpdate:value": _cache[3] || (_cache[3] = $event => $data.auth_uid = $event),
          "show-search": "",
          ref: "select",
          style: {
            "width": "100%"
          },
          placeholder: _ctx.$t('ph_auth'),
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.accountList, (item, index) => {
            return _openBlock(), _createBlock(_component_a_select_option, {
              value: item.id,
              key: index
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name) + "-" + _toDisplayString(item.id), 1)]),
              _: 2
            }, 1032, ["value"]);
          }), 128))]),
          _: 1
        }, 8, ["getPopupContainer", "value", "placeholder", "onChange"]), [[_vShow, $data.accountList.length > 0]]), !$data.privateDeploy ? (_openBlock(), _createBlock(_component_a_row, {
          key: 1,
          class: "margin-top-1"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 3
          }, {
            default: _withCtx(() => [$data.activeKey == '1' || $data.activeKey == '2' ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[4] || (_cache[4] = (...args) => $options.goToRegister && $options.goToRegister(...args))
            }, _toDisplayString(_ctx.$t('register')), 1)) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 13
          }), _createVNode(_component_a_col, {
            span: 8,
            align: "right"
          }, {
            default: _withCtx(() => [$data.activeKey == '1' ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[5] || (_cache[5] = (...args) => $options.goToFind && $options.goToFind(...args))
            }, _toDisplayString(_ctx.$t('forget')), 1)) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), $data.activeKey === '4' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_row, {
          style: {
            "margin-bottom": "8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('ver_code')) + "：", 1), _createVNode(_component_a_input, {
              value: $data.verCode,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => $data.verCode = $event),
              style: {
                "width": "340px",
                "height": "35px"
              },
              placeholder: _ctx.$t('ph_login_ver_code')
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          })]),
          _: 1
        })])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
          type: "primary",
          onClick: $options.goTo,
          onKeyup: _withKeys($options.goTo, ["enter"]),
          block: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('login')), 1)]),
          _: 1
        }, 8, ["onClick", "onKeyup"]), _createVNode(_component_a_tag, {
          color: "blue",
          class: "mt-3"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('recommend')), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["title"])])]),
      _: 1
    }), _createVNode(_component_a_layout_footer, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('copyright')), 1)]),
      _: 1
    })]),
    _: 1
  })]);
}